import { render, staticRenderFns } from "./addClassifyDialog.vue?vue&type=template&id=06ebc1af&scoped=true"
import script from "./addClassifyDialog.vue?vue&type=script&lang=js"
export * from "./addClassifyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebc1af",
  null
  
)

export default component.exports